import React, { Component } from 'react';
import { bool, func, object, oneOf, shape, string } from 'prop-types';
import { Field } from 'react-final-form';
import classNames from 'classnames';

import css from './FieldRecaptcha.module.css';
import config from '../../config';
import { apiBaseUrl } from '../../util/api';
import axios from '../../util/axiosHelper';
import { injectIntl } from 'react-intl';

class FieldRecaptchaComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasRecaptchaValidated: props.initialValue.hasRecaptchaValidated ?? false,
      isRecaptchaInvalid: props.initialValue.isRecaptchaInvalid ?? false,
    };
    this.mounted = false;
    this.recaptchRef = React.createRef();
    this.widgetId = null;
  }

  componentWillUnmount() {
    // if (
    //   this.mounted &&
    //   this.widgetId &&
    //   typeof window !== 'undefined' &&
    //   typeof window.grecaptcha !== 'undefined' &&
    //   typeof window.grecaptcha.reset === 'function'
    // ) {
    //   window.grecaptcha.reset(this.widgetId);
    //   this.mounted = false;
    //   this.recaptchRef.current = null;
    // }
  }

  handlePropChange = value => {
    const { onChange, name } = this.props;
    onChange({ [name]: value });
  };

  handleChange = value => {
    this.setState({ ...value });
    this.handlePropChange(value);
  };

  recaptchaResponse = async token => {
    const data = { isRecaptchaInvalid: false, hasRecaptchaValidated: false };
    try {
      this.handleChange(data);
      const url = `${apiBaseUrl()}/api/user/validate/recaptcha`;
      await axios.post(url, { token: token });
      data.hasRecaptchaValidated = true;
      this.handleChange(data);
    } catch (err) {
      data.isRecaptchaInvalid = true;
      this.handleChange(data);
    }
  };

  recaptchDivCallback = el => {
    if (
      !this.mounted &&
      el &&
      typeof window !== 'undefined' &&
      typeof window.grecaptcha !== 'undefined' &&
      typeof window.grecaptcha.render === 'function'
    ) {
      this.recaptchRef = el;
      this.mounted = true;
      this.widgetId = window.grecaptcha.render('g-recaptcha', {
        sitekey: config.recaptchaKey,
        callback: this.recaptchaResponse,
      });
    } else {
      if (!!el) {
        setTimeout(() => this.recaptchDivCallback(el), 250);
      }
    }
  };
  render() {
    /* eslint-disable no-unused-vars */
    const { rootClassName, className, customErrorText, id, enableRecaptcha, intl } = this.props;
    /* eslint-enable no-unused-vars */

    const errorText = customErrorText || intl.formatMessage({ id: 'SignupForm.invalidRecaptcha' });
    const { hasRecaptchaValidated = false, isRecaptchaInvalid = false } = this.state;

    const classes = classNames(rootClassName || css.root, className);
    return hasRecaptchaValidated ? null : (
      <div className={classes} id={id}>
        <div
          id="g-recaptcha"
          className={classNames(css.recaptchDiv, {
            [css.enabledRecaptchaDiv]: enableRecaptcha,
          })}
          ref={this.recaptchDivCallback}
        />
        {isRecaptchaInvalid && <p className={css.invalidRecaptchaMsg}>{errorText}</p>}
      </div>
    );
  }
}

FieldRecaptchaComponent.defaultProps = {
  rootClassName: null,
  className: null,
  customErrorText: null,
  id: null,
  enableRecaptcha: true,
  onChange: null,
  initialValue: { hasRecaptchaValidated: false, isRecaptchaInvalid: false },
};

FieldRecaptchaComponent.propTypes = {
  rootClassName: string,
  className: string,
  name: string.isRequired,

  // Error message that can be manually passed to input field,
  // overrides default validation message
  customErrorText: string,

  // Label is optional, but if it is given, an id is also required so
  // the label can reference the input in the `for` attribute
  id: string,
  initialValue: shape({
    hasRecaptchaValidated: bool.isRequired,
    isRecaptchaInvalid: bool.isRequired,
  }).isRequired,

  enableRecaptcha: bool.isRequired,
  onChange: func.isRequired,
};

const FieldRecaptcha = injectIntl(FieldRecaptchaComponent);

// function FieldRecaptcha(props) {
//   return <Field component={} {...props} type="hidden" />;
// }

export default FieldRecaptcha;
